import Vue from "vue";
import Vuex from "vuex";
import { mutations } from "./mutations.js";
import { actions } from "./actions.js";
import { getters } from "./getters.js";
Vue.use(Vuex);


/**
 * localStorage数据用户可在浏览器可篡改 
 * userInfos、authInfos 用于显示无太大影响，用于验证类操作隐患巨大
 * userInfos、authInfos 页码中禁止用于实名判断等验证需求
 * 页面中用于显示 可直接获取localStorage数据 无需再store.js中赋值state
 * 鉴于项目定型防止崩溃，localStorage所赋值的userInfos、authInfos不做改动
 * 
 * 优化：新增独立 state 数据 strictCtrlInfo 存储安全数据 
 */
const INFO = JSON.parse(localStorage.getItem('userInfo')) || {}
const state = {
  count: 0,
  username: '',
  routerList: {},
  userInfos: INFO.user || {},
  authInfos: INFO.auth || {},
  strictCtrlInfo: {},
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/vuex/store.js